import AppOrganizationPage from './AppOrganizationPage';

export default AppOrganizationPage;